import React from "react";

export default function BrandStep2({

    form,

    updateField

}) {

    return (

        <div>

            <h2
                style={{
                    marginBottom: 6
                }}
            >
                Business Contact Details
            </h2>

            <p
                style={{
                    color: "#777",
                    marginBottom: 28
                }}
            >
                Tell customers how they can contact your business.
            </p>

            {/* Owner Name */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Owner / Representative Name *
                </label>

                <input

                    type="text"

                    value={form.ownerName}

                    onChange={(e)=>

                        updateField(
                            "ownerName",
                            e.target.value
                        )

                    }

                    placeholder="Full Name"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Email */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Business Email *
                </label>

                <input

                    type="email"

                    value={form.email}

                    onChange={(e)=>

                        updateField(
                            "email",
                            e.target.value
                        )

                    }

                    placeholder="name@company.com"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Phone */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Business Phone *
                </label>

                <input

                    type="tel"

                    value={form.phone}

                    onChange={(e)=>

                        updateField(
                            "phone",
                            e.target.value
                        )

                    }

                    placeholder="+91 XXXXX XXXXX"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Website */}

            <div
                style={{
                    marginBottom: 22
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Website
                </label>

                <input

                    type="url"

                    value={form.website}

                    onChange={(e)=>

                        updateField(
                            "website",
                            e.target.value
                        )

                    }

                    placeholder="https://www.example.com"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Address */}

            <div
                style={{
                    marginBottom: 25
                }}
            >

                <label
                    style={{
                        display: "block",
                        marginBottom: 8,
                        fontWeight: 600
                    }}
                >
                    Business Address
                </label>

                <textarea

                    rows={4}

                    value={form.address}

                    onChange={(e)=>

                        updateField(
                            "address",
                            e.target.value
                        )

                    }

                    placeholder="Street, City, State, Country"

                    style={{
                        width: "100%",
                        padding: 14,
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        resize: "vertical",
                        fontSize: 15,
                        outline: "none"
                    }}

                />

            </div>

            {/* Contact Preview */}

            <div
                style={{
                    marginTop: 30,
                    padding: 20,
                    borderRadius: 12,
                    background: "#F8FAFC",
                    border: "1px solid #E2E8F0"
                }}
            >

                <div
                    style={{
                        fontWeight: 600,
                        marginBottom: 12
                    }}
                >
                    Contact Preview
                </div>

                <div
                    style={{
                        lineHeight: 1.8,
                        color: "#555"
                    }}
                >

                    <div>

                        <strong>Owner:</strong>{" "}
                        {form.ownerName || "-"}

                    </div>

                    <div>

                        <strong>Email:</strong>{" "}
                        {form.email || "-"}

                    </div>

                    <div>

                        <strong>Phone:</strong>{" "}
                        {form.phone || "-"}

                    </div>

                    <div>

                        <strong>Website:</strong>{" "}
                        {form.website || "-"}

                    </div>

                    <div>

                        <strong>Address:</strong>{" "}
                        {form.address || "-"}

                    </div>

                </div>

            </div>

        </div>

    );

}